import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageHero from "@/components/PageHero";

export default function Devotionals() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/devotionals?limit=30").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);
  const [today, ...rest] = items;

  return (
    <>
      <PageHero
        eyebrow="Daily Devotional"
        title="A moment with Scripture."
        subtitle="A short daily reflection to anchor your day in the Word of God."
      />
      <section className="py-16 sm:py-24">
        <div className="container-editorial grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-8">
            {today ? (
              <article className="paper-card p-10">
                <p className="eyebrow text-forest">{new Date(today.date).toDateString()}</p>
                <h2 className="heading-2 mt-3">{today.title}</h2>
                <p className="mt-2 eyebrow">{today.scripture}</p>
                <div className="mt-8 prose-editorial" dangerouslySetInnerHTML={{ __html: today.body }} />
                {today.prayer && (
                  <div className="mt-10 border-l-2 border-gold pl-6">
                    <p className="eyebrow">A short prayer</p>
                    <p className="mt-3 font-serif text-xl italic text-ink" style={{ fontWeight: 500 }}>
                      {today.prayer}
                    </p>
                  </div>
                )}
              </article>
            ) : (
              <p className="text-ink-muted">No devotional today. Please check back tomorrow.</p>
            )}
          </div>
          <div className="md:col-span-4">
            <p className="eyebrow">Recent devotionals</p>
            <div className="mt-4 space-y-4">
              {rest.map((d) => (
                <div key={d.id} className="paper-card p-5">
                  <p className="text-xs text-ink-muted">{new Date(d.date).toDateString()}</p>
                  <p className="font-serif text-lg mt-2 text-ink" style={{ fontWeight: 500 }}>{d.title}</p>
                  <p className="text-xs eyebrow mt-2">{d.scripture}</p>
                </div>
              ))}
              {rest.length === 0 && <p className="text-ink-muted text-sm">More coming soon.</p>}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
